"use client"

import { Framer } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `FramerIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const FramerIcon = component(Icon)({ as: Framer })
